import style from "./Index.module.scss";
import { useRef } from "react";
import { CSSTransition } from "react-transition-group";

interface Props {
  show: boolean;
}

export default function SavedToast({ show }: Props) {
  const nodeRef = useRef(null);
  
  return (
    <CSSTransition
      in={show}
      nodeRef={nodeRef}
      timeout={3000}
      classNames="fade"
      unmountOnExit
    >
      <div className={style.Container} ref={nodeRef}>
        <div className={style.Message}>Saved</div>
      </div>
    </CSSTransition>
  );
}
